import React from 'react'
import { formatDate } from '../../../../../utils/functions'

const SponserCommissionTable = ({ sponserCommissionsData }) => {
	return (
		<>
			{sponserCommissionsData?.length > 0 ? (
				<div className='table-responsive'>
					<table className='table table-hover'>
						<thead>
							<tr>
								<th className='text-center' style={{ backgroundColor: '#fcf5f0', color: 'black' }}>
									SR NO
								</th>
								<th className='text-center' style={{ backgroundColor: '#fcf5f0', color: 'black' }}>
									Date
								</th>
								<th className='text-center' style={{ backgroundColor: '#fcf5f0', color: 'black' }}>
									User Id
								</th>
								<th className='text-center' style={{ backgroundColor: '#fcf5f0', color: 'black' }}>
									User Name
								</th>
								<th className='text-center' style={{ backgroundColor: '#fcf5f0', color: 'black' }}>
									Sponser Commission
								</th>
							</tr>
						</thead>
						<tbody>
							{sponserCommissionsData.map((item, index) => (
								<tr key={item._id?.toString() || index}>
									<td className='text-center' style={{ color: 'black', backgroundColor: 'white' }}>
										{index + 1}
									</td>
									<td className='text-center' style={{ color: 'black', backgroundColor: 'white' }}>
										{formatDate(item.dateOfPurchase)}
									</td>
									<td className='text-center' style={{ color: 'black', backgroundColor: 'white' }}>
										{item?.registerId}
									</td>
									<td className='text-center' style={{ color: 'black', backgroundColor: 'white' }}>
										{item?.userName}
									</td>
									<td className='text-center' style={{ color: 'black', backgroundColor: 'white' }}>
										{item?.sponserCommission}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			) : (
				<div className='text-center p-5'>
					<p className='h4 text-dark'>No Data Available</p>
				</div>
			)}
		</>
	)
}

export default SponserCommissionTable
